<template>
  <div id="contenedor-registro-solicitud-pago">
    <v-form
      v-model="formularioValido"
      ref="registrarSolicitudPago">
      <v-row>
        <v-col
          cols="12"
          md="6">
          <custom-text-field
            v-model="solicitud.folio"
            label="Folio"
            :rules="[mixReglas.requerido]">
          </custom-text-field>
        </v-col>
        <date-picker
          v-model="solicitud.fecha"
          label="Fecha"
          cols="12"
          md="6"
          :rules="[mixReglas.requerido]">
        </date-picker>
        <v-col
          cols="12">
          <v-divider></v-divider>
        </v-col>
        <custom-auto-complete
          v-model="idContratista"
          cols="12"
          md="12"
          label="Contratista"
          :items="mixGetContratistas"
          item-text="nombreRazonSocial"
          item-value="id">
        </custom-auto-complete>
        <custom-auto-complete
          v-model="solicitud.idContrato"
          cols="12"
          md="12"
          label="Contrato"
          :items="mixGetContratosPorContratista"
          item-text="numero"
          item-value="id">
        </custom-auto-complete>
        <v-col
          cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-subheader>
        <span
          class="text-h5">
          Detalles
        </span>
        <v-spacer></v-spacer>
        <v-btn
          @click="mostrarAgregarDetalle = !mostrarAgregarDetalle"
          rounded
          :disabled="getReferenciasSinHeaders.length <= 0"
          color="success">
          <v-icon>
            mdi-plus
          </v-icon>
          agregar
        </v-btn>
      </v-subheader>
      <listado-detalles
        :referencias="referenciasSeleccionadas"
        @removerReferencia="removerReferencia">
      </listado-detalles>
    </v-form>
    <v-dialog
      v-model="mostrarAgregarDetalle"
      v-if="mostrarAgregarDetalle"
      width="500"
      persistent>
      <v-card>
        <v-card-title class="secondary--text">
          Agregar detalle
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarAgregarDetalle = !mostrarAgregarDetalle">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <agregar-detalle
            key="agDetalleSolicitud"
            ref="agregarDetalleSolicitud"
            :referencias="getReferencias"
            :referenciasSeleccionadas="referenciasSeleccionadas">
          </agregar-detalle>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3"
            @click="mostrarAgregarDetalle = !mostrarAgregarDetalle">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Agregar"
            @click="$refs.agregarDetalleSolicitud.agregar()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixPagos from '../mixPagos';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';
import AgregarDetalle from './AgregarDetalle.vue';
import ListadoDetalles from './ListadoDetalles.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'RegistrarNuevaSolicitudDePago',
  mixins: [mixPagos, mixSubirArchivo],
  components: {
    CustomTextField,
    DatePicker,
    CustomAutoComplete,
    CustomButton,
    AgregarDetalle,
    ListadoDetalles,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarAgregarDetalle: false,
      archivoPublicKey: '',
      idContratista: '',
      referenciasSeleccionadas: [],
      solicitud: {
        idContrato: '',
        folio: '',
        fecha: '',
        detalles: [],
      },
    };
  },
  methods: {
    agregarReferencia(referencia) {
      if (!referencia) return;
      this.referenciasSeleccionadas.push(referencia);
    },
    removerReferencia(index) {
      this.referenciasSeleccionadas.splice(index, 1);
    },
    async guardar() {
      // Subir los archivos pdf y xml y guardar public keys
      const referenciasConArchivos = await Promise.all(this.referenciasSeleccionadas
        .map(async (detalle) => {
          const nuevoDetalle = detalle;
          // si existe archivo pdf se sube y se guarda la publicKey
          if (nuevoDetalle.archivoPdf) {
            const datosArchivo = {
              nombre: `${detalle.numeroFactura}_${detalle.referencia.tipo}_${detalle.referencia.numero}`,
              path: 'Pagos/Detalles Solicitudes/2022',
              archivo: detalle.archivoPdf,
            };
            await this.mixSubirArchivo(datosArchivo);
            nuevoDetalle.pdfPublicKey = this.archivoPublicKey;
            this.archivoPublicKey = null;
          }
          // si existe archivo xml se sube y se guarda la publicKey
          if (detalle.archivoXml) {
            const datosArchivo = {
              nombre: `${detalle.numeroFactura}_${detalle.referencia.tipo}_${detalle.referencia.numero}`,
              path: 'Pagos/Detalles Solicitudes/2022',
              archivo: detalle.archivoXml,
            };
            await this.mixSubirArchivo(datosArchivo);
            nuevoDetalle.xmlPublicKey = this.archivoPublicKey;
            this.archivoPublicKey = null;
          }
          return nuevoDetalle;
        }));

      // Formatear los detalles
      this.formatearDetalles(referenciasConArchivos);

      await this.mixGuardarSolicitudPago();
    },

    formatearDetalles(referencias) {
      const detallesFormateados = referencias.map((detalle) => ({
        idReferencia: detalle.idReferencia,
        numeroFactura: detalle.numeroFactura,
        fechaFactura: detalle.fechaFactura,
        importe: detalle.importe,
        pdfPublicKey: detalle.pdfPublicKey,
        xmlPublicKey: detalle.xmlPublicKey,
      }));
      this.solicitud.detalles = detallesFormateados;
    },
    cerrar() {
      this.referenciasSeleccionadas = [];
      this.solicitud.folio = '';
      this.solicitud.fecha = '';
      this.solicitud.detalles = [];

      this.$emit('cerrar');
    },
  },
  computed: {
    getReferencias() {
      return this.mixReferenciasDePagoDisponibles
      // Filtrar las referencias ya agregadas
        .filter(({ id }) => !this.referenciasSeleccionadas
          .map(({ idReferencia }) => idReferencia).includes(id));
    },
    getReferenciasSinHeaders() {
      return this.getReferencias.filter(({ header }) => header === undefined);
    },
  },
  mounted() {
    eventBus.$on('seCargoArchivo', (archivo) => {
      this.archivoPublicKey = archivo.data.public_key;
    });
  },
  watch: {
    referenciasSeleccionadas: {
      handler(referencias) {
        if (this.formularioValido && referencias.length > 0) {
          this.$emit('formularioValido', true);
        } else {
          this.$emit('formularioValido', false);
        }
      },
    },
    formularioValido: {
      handler(valor) {
        const hayReferenciasSeleccionadas = this.referenciasSeleccionadas.length > 0;

        if (valor && hayReferenciasSeleccionadas) {
          this.$emit('formularioValido', true);
        } else {
          this.$emit('formularioValido', false);
        }
      },
    },
    enviandoFormulario: {
      handler(valor) {
        this.$emit('enviandoFormulario', valor);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
